// Version : 0.0.3
// Author : VISHNU
// LastEdit : Sabari
// Last ADD : Unwanted Redux Clear
// MODFIED DATE : 11-11-2025
import ChangeGroupOfficerActionTypes from './change-group-officer.type';

/** ***************** GET OFFICER BASED ON CHANGE BRANCH DETAILS START *********************** */
export const getChangeBranchOfficerDetailsStart = (getData: any) => ({
	type: ChangeGroupOfficerActionTypes.GET_CHANGE_BRANCH_OFFICER_LIST_START,
	payload: getData,
});

export const getChangeBranchOfficerDetailsSuccess = (successData: any) => ({
	type: ChangeGroupOfficerActionTypes.GET_CHANGE_BRANCH_OFFICER_LIST_SUCCESS,
	payload: successData,
});

export const getChangeBranchOfficerDetailsFailure = (failureData: any) => ({
	type: ChangeGroupOfficerActionTypes.GET_CHANGE_BRANCH_OFFICER_LIST_FAILURE,
	payload: failureData,
});

export const getChangeBranchOfficerDetailsResponseResetStart = () => ({
	type: ChangeGroupOfficerActionTypes.GET_CHANGE_BRANCH_OFFICER_LIST_RESPONSE_RESET,
});

export const getChangeBranchOfficerDetailsResponseChanged = () => ({
	type: ChangeGroupOfficerActionTypes.GET_CHANGE_BRANCH_OFFICER_LIST_RESPONSE_CHANGED,
});
/** ***************** GET OFFICER BASED ON CHANGE BRANCH DETAILS END *********************** */

/** ***************** GET CENTER BASED ON OFFICER DETAILS START *********************** */
export const getOfficerCenterDetailsStart = (getData: any) => ({
	type: ChangeGroupOfficerActionTypes.GET_OFFICER_CENTER_LIST_START,
	payload: getData,
});

export const getOfficerCenterDetailsSuccess = (successData: any) => ({
	type: ChangeGroupOfficerActionTypes.GET_OFFICER_CENTER_LIST_SUCCESS,
	payload: successData,
});

export const getOfficerCenterDetailsFailure = (failureData: any) => ({
	type: ChangeGroupOfficerActionTypes.GET_OFFICER_CENTER_LIST_FAILURE,
	payload: failureData,
});

export const getOfficerCenterDetailsResponseResetStart = () => ({
	type: ChangeGroupOfficerActionTypes.GET_OFFICER_CENTER_LIST_RESPONSE_RESET,
});

export const getOfficerCenterDetailsResponseChanged = () => ({
	type: ChangeGroupOfficerActionTypes.GET_OFFICER_CENTER_LIST_RESPONSE_CHANGED,
});
/** ***************** GET CENTER BASED ON OFFICER DETAILS END *********************** */

/** ***************** GET LOAN GROUP BASED ON CENTER DETAILS START *********************** */
export const getLoanGroupBasedOnCenter = (getData: any) => ({
	type: ChangeGroupOfficerActionTypes.GET_LOAN_GROUP_LIST_START,
	payload: getData,
});

export const getLoanGroupDetailsSuccess = (successData: any) => ({
	type: ChangeGroupOfficerActionTypes.GET_LOAN_GROUP_LIST_SUCCESS,
	payload: successData,
});

export const getLoanGroupDetailsFailure = (failureData: any) => ({
	type: ChangeGroupOfficerActionTypes.GET_LOAN_GROUP_LIST_FAILURE,
	payload: failureData,
});

export const getLoanGroupDetailsResponseResetStart = () => ({
	type: ChangeGroupOfficerActionTypes.GET_LOAN_GROUP_LIST_RESPONSE_RESET,
});

export const getLoanGroupDetailsResponseChanged = () => ({
	type: ChangeGroupOfficerActionTypes.GET_LOAN_GROUP_LIST_RESPONSE_CHANGED,
});
/** ***************** GET CENTER BASED ON OFFICER DETAILS END *********************** */

/** ***************** UPDATE CHANGE GROUP OFFICER DETAILS START *********************** */
export const updateChangeGroupOfficerDetailsStart = (getData: any) => ({
	type: ChangeGroupOfficerActionTypes.UPDATE_CHANGE_GROUP_OFFICER_LIST_START,
	payload: getData,
});

export const updateChangeGroupOfficerDetailsSuccess = (successData: any) => ({
	type: ChangeGroupOfficerActionTypes.UPDATE_CHANGE_GROUP_OFFICER_LIST_SUCCESS,
	payload: successData,
});

export const updateChangeGroupOfficerDetailsFailure = (failureData: any) => ({
	type: ChangeGroupOfficerActionTypes.UPDATE_CHANGE_GROUP_OFFICER_LIST_FAILURE,
	payload: failureData,
});

export const updateChangeGroupOfficerDetailsResponseResetStart = () => ({
	type: ChangeGroupOfficerActionTypes.UPDATE_CHANGE_GROUP_OFFICER_LIST_RESPONSE_RESET,
});

export const updateChangeGroupOfficerDetailsResponseChanged = () => ({
	type: ChangeGroupOfficerActionTypes.UPDATE_CHANGE_GROUP_OFFICER_LIST_RESPONSE_CHANGED,
});
/** ***************** UPDATE CHANGE GROUP OFFICER END *********************** */
